export enum WorkReportScope {
  workingSite, user
}
